function createModalController() {
  return {
    msgBoxConfirm(message) {
      const msg = typeof message === 'string' ? message : 'Confirmer cette action ?'

      return new Promise((resolve) => {
        const overlay = document.createElement('div')
        overlay.setAttribute('role', 'dialog')
        overlay.setAttribute('aria-modal', 'true')
        overlay.style.cssText = [
          'position:fixed',
          'inset:0',
          'z-index:9050',
          'background:rgba(15,27,50,0.45)',
          'display:flex',
          'align-items:center',
          'justify-content:center',
          'padding:24px',
        ].join(';')

        const panel = document.createElement('div')
        panel.style.cssText = [
          'background:var(--color-surface)',
          'border:1px solid var(--color-border)',
          'border-radius:var(--r-lg)',
          'box-shadow:var(--shadow-lg)',
          'width:100%',
          'max-width:380px',
          'font-family:var(--font-sans)',
          'overflow:hidden',
        ].join(';')

        panel.innerHTML = `
          <div style="padding:20px;display:flex;align-items:flex-start;gap:12px;">
            <div style="width:36px;height:36px;border-radius:var(--r-md);background:var(--color-surface-2);color:var(--color-text-muted);display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
            </div>
            <div>
              <div style="font-size:15px;font-weight:600;color:var(--color-text);letter-spacing:-0.01em;">Confirmer cette action</div>
              <div style="font-size:13px;color:var(--color-text-muted);margin-top:4px;line-height:1.4;">${msg}</div>
            </div>
          </div>
          <div style="display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;border-top:1px solid var(--color-border);background:var(--color-surface-2);">
            <button id="mf-dlg-cancel" style="height:38px;padding:0 14px;border-radius:var(--r-md);border:1px solid var(--color-border);background:var(--color-surface);color:var(--color-text);font-weight:500;font-size:13px;cursor:pointer;font-family:var(--font-sans);">Annuler</button>
            <button id="mf-dlg-ok" style="height:38px;padding:0 18px;border-radius:var(--r-md);border:none;background:var(--color-primary);color:white;font-weight:600;font-size:13px;cursor:pointer;font-family:var(--font-sans);">Confirmer</button>
          </div>
        `

        overlay.appendChild(panel)
        document.body.appendChild(overlay)

        function cleanup(result) {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
          document.removeEventListener('keydown', onKeydown)
          resolve(result)
        }

        function onKeydown(e) {
          if (e.key === 'Escape') { e.preventDefault(); cleanup(false) }
          if (e.key === 'Enter') { e.preventDefault(); cleanup(true) }
        }

        overlay.addEventListener('click', (e) => { if (e.target === overlay) cleanup(false) })
        panel.querySelector('#mf-dlg-cancel').addEventListener('click', () => cleanup(false))
        panel.querySelector('#mf-dlg-ok').addEventListener('click', () => cleanup(true))
        document.addEventListener('keydown', onKeydown)

        setTimeout(() => panel.querySelector('#mf-dlg-ok')?.focus(), 50)
      })
    }
  }
}

export function installBvModalCompat(app) {
  const modalController = createModalController()
  app.config.globalProperties.$bvModal = modalController
  return modalController
}
